<template>
  <div class="baiduQueue">
      <div class="box">
          <div class="b1">{{item.orgaName}}</div>
          <div class="b2">
              <!-- <div>
                  <img src="/static/index/index9.png" alt="">
                  <div>江苏省南京市玄武区</div>
              </div> -->
              <div>
                  <img src="/static/index/index10.png" alt="">
                  <div>咨询电话：{{item.telephone}}</div>
              </div>
          </div>
          <div class="title">介绍</div>
          <div class="remark">{{item.product}}</div>
          <div class="title">所属行业</div>
          <div class="remark">{{item.industry}}</div>
          <div class="title">企业介绍</div>
          <div class="remark">{{item.introduce}}</div>
          <div class="title">产品图片</div>
          <div class="img" v-if="item.imageUrl">
               <img v-for="(items,index) in item.imageUrl.split(',')" :key="index" :src="items" alt="">
          </div>
      </div>
  </div>
</template>

<script>
import Cookie from "js-cookie";
export default {
  title: "课程列表",
  data() {
    return {
      item:{}
    };
  },
  computed: {},
  components: {},
  methods: {
    getData() {
      this.$axios.post('/get_retailer_detail',this.$qs.stringify({rid:this.$route.query.id}) ).then(res => {
					this.item=res.data.data

				})
    },
  },

  mounted() {
    this.getData();  
  },
};
</script>  
<style lang="scss" scoped>
.baiduQueue{
  width: 100%;
  // height: 100%;
  // overflow-y: auto;
  background: #FFFFFF;
  display: flex;
  flex-direction: column;
  padding-top: 62px;
  padding-bottom: 92px;
  .box{
      width: 1132px;
      padding: 0 34px;
      margin: 0 auto;
    .b1{
        font-size: 40px;
font-family: SourceHanSansCN-Bold, SourceHanSansCN;
font-weight: bold;
color: #333333;
text-align: center;
margin-bottom: 30px;

    }
    .b2{
        display: flex;
        align-items: center;
        justify-content: center;
        &>div{
            display: flex;
            align-items: center;
            margin-right: 69px;
            img{
                width: 18px;
                height: 18px;
                margin-right: 3px;
            }
            div{
                font-size: 24px;
                font-family: SourceHanSansCN-Regular, SourceHanSansCN;
                font-weight: 400;
                color: #999999;
            }
        }
    }
    .title{
        font-size: 24px;
font-family: SourceHanSansCN-Bold, SourceHanSansCN;
font-weight: bold;
color: #333333;
margin-bottom: 20px;
    }
    .remark{
        font-size: 20px;
font-family: SourceHanSansCN-Regular, SourceHanSansCN;
font-weight: 400;
color: #333333;
margin-bottom: 50px;
    }
    .img{
        margin-bottom: 50px;
        img{
            width: 100%;
            margin-bottom: 20px;
        }
    }
  }
}
</style>  


// WEBPACK FOOTER //
// src/pages/enterpriseDetail/index.vue